import general from './general';
import forms from './forms';
import dataLists from './dataLists';
import sideBar from './sideBar';
import errorNotifications from './errorNotifications';
import labels from './labels';
import tooltips from './tooltips';
import sections from './sections';
import tablesAndFilters from './tablesAndFilters';
import successNotifications from './successNotifications';

export default {
  general,
  forms,
  dataLists,
  sideBar,
  errorNotifications,
  labels,
  tooltips,
  sections,
  tablesAndFilters,
  successNotifications
};
